import React, { useEffect, useState } from 'react';
import { BookOpenIcon, StarIcon } from 'lucide-react';
export const Hero = () => {
  const [copiesLeft, setCopiesLeft] = useState(23);
  // Get initial count from cookie or set default
  useEffect(() => {
    const getCookieValue = name => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    };
    const savedCount = getCookieValue('copiesLeft');
    const initialCount = savedCount ? parseInt(savedCount) : 23;
    setCopiesLeft(initialCount > 2 ? initialCount : 23); // Reset to 23 if below threshold
  }, []);
  // Set up countdown timer
  useEffect(() => {
    // Save count to cookie
    const saveCookie = count => {
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 7); // Cookie expires in 7 days
      document.cookie = `copiesLeft=${count};expires=${expiryDate.toUTCString()};path=/`;
    };
    // Don't continue countdown if we've reached 2
    if (copiesLeft <= 2) {
      saveCookie(2);
      return;
    }
    const timer = setInterval(() => {
      setCopiesLeft(prev => {
        const newCount = prev - 1;
        // Don't go below 2
        if (newCount <= 2) {
          clearInterval(timer);
          saveCookie(2);
          return 2;
        }
        saveCookie(newCount);
        return newCount;
      });
    }, 3000);
    return () => clearInterval(timer); // Clean up on unmount
  }, [copiesLeft]);
  return <div className="relative bg-[#f8f8f8] overflow-hidden" data-id="element-161">
      <div className="max-w-7xl mx-auto" data-id="element-162">
        <div className="relative z-10 pb-8 bg-[#f8f8f8]" data-id="element-163">
          <main className="pt-10 px-4 sm:pt-12 sm:px-6 md:pt-16 lg:pt-20" data-id="element-164">
            <div className="text-center lg:text-left" data-id="element-165">
              <div className="flex justify-center lg:justify-start mb-4" data-id="element-166">
                <div className="flex space-x-1" data-id="element-167">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-500" fill="#EAB308" data-id="element-168" />)}
                </div>
                <span className="ml-2 text-sm text-gray-600" data-id="element-169">
                  Limited Edition Keepsake
                </span>
              </div>
              <h1 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl md:text-5xl lg:text-6xl" data-id="element-170">
                <span className="block text-[#0A2463]" data-id="element-171">A Family Keepsake</span>
                <span className="block text-[#990000]" data-id="element-172">of Values</span>
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0" data-id="element-173">
                Preserve Faith, Freedom, and the American Dream for Generations
              </p>
              <div className="mt-8 flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 sm:justify-center lg:justify-start" data-id="element-174">
                <a href="#order" className="w-full flex items-center justify-center px-10 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#990000] hover:bg-[#7A0000] md:py-4 md:px-12 md:text-lg" data-id="element-175">
                  Order Now — Preserve the Legacy
                </a>
                <a href="#learn-more" className="w-full flex items-center justify-center px-10 py-3 border border-transparent text-base font-medium rounded-md text-[#0A2463] bg-white border-[#0A2463] hover:bg-gray-50 md:py-4 md:px-12 md:text-lg" data-id="element-176">
                  Learn More
                  <BookOpenIcon className="ml-2 h-5 w-5" data-id="element-177" />
                </a>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div className="mt-8 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:mt-0" data-id="element-178">
        <div className="relative mx-auto" data-id="element-179">
          {/* Chrome LIMITED EDITION badge */}
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 z-10 w-64 max-w-full" data-id="element-180">
            <div className="bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300 text-center py-1 px-4 rounded-md shadow-md border border-gray-200" data-id="element-181">
              <span className="font-bold text-lg text-[#990000] tracking-wider" style={{
              textShadow: '0px 1px 1px rgba(255,255,255,0.7)'
            }} data-id="element-182">
                LIMITED EDITION
              </span>
            </div>
          </div>
          <img className="h-auto w-full max-w-xs mx-auto object-contain sm:max-w-sm md:max-w-md lg:max-w-none lg:h-full" src="https://uploadthingy.s3.us-west-1.amazonaws.com/kPDZid9qnAoKWPENh23247/Generated_Image_September_25%2C_2025_-_3_46PM.png" alt="A Family Keepsake of Values book" data-id="element-183" />
          {/* Countdown - few units left - with dynamic counter */}
          <div className="absolute bottom-4 right-4 z-10 bg-[#990000] text-white py-1.5 px-3 rounded-md shadow-md" data-id="element-184">
            <div className="text-center" data-id="element-185">
              <span className="font-bold text-sm" data-id="element-186">
                ONLY {copiesLeft} COPIES LEFT
              </span>
              <div className="text-xs" data-id="element-187">Order now before they're gone</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};